import { HStack, VStack } from "@chakra-ui/react";
import React from "react";
import PluginNavigation from "./PluginNavigation";
import {
  useView,
} from "../../../hooks";
import { PluginView } from "../../../enums";

/**
 * Renders the plugin content
 * 
 * @param {Object} props - The props of the component
 * @returns The plugin content
 */
const PluginContent = ({ children }) => {
  const { pluginView } = useView();

  return pluginView === PluginView.COMPACT ? null : (
    <HStack alignItems={"stretch"} gap={"16px"} height={"full"}>
      <PluginNavigation />
      <VStack position={"relative"} width={"full"} flexGrow={1} height={"full"} justifyItems={"stretch"} alignItems={"stretch"}>
        {children}
      </VStack>
    </HStack>
  );
};

export default React.memo(PluginContent);
